import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {SignUpConfirm, SignUpConfirmParams} from 'domain/usecases';

export class RemoteSignUpConfirm implements SignUpConfirm {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<void>,
	) {}

	async signUpConfirm({signal, ...bodyParams}: SignUpConfirmParams): Promise<void> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: bodyParams,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
